module.exports = __webpack_public_path__ + "img/nologo.684ea81e.svg";